import Swiper from "swiper";
import {Autoplay,  Mousewheel, Navigation, Pagination} from "swiper/modules";

$(function () {
    const $otherProjectsSwiper = $('.other-projects-swiper')

    if ($otherProjectsSwiper.length) {
        $otherProjectsSwiper.find('.swiper-slide').shuffle();

        const swiper = new Swiper($otherProjectsSwiper.get(0), {
            modules: [Mousewheel, Pagination, Autoplay],
            preloadImages: true,
            lazy: {
                loadPrevNext: true,
                // loadOnTransitionStart: true,
                loadPrevNextAmount: 1
            },
            centeredSlides: true,
            loop: true,
            autoplay: false,
            slideToClickedSlide: true,
            // slidesPerView: 3.5,
            spaceBetween: 15,
            //
            breakpoints: {
                320: {
                    slidesPerView: 1.5,
                },
                768: {
                    slidesPerView: 2.5,
                },
            },
            // pagination: {
            //     el: ".swiper-pagination",
            //     clickable: true
            // },
        })
    }

});
